import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { doNothing } from '@src/utils/utils';

export interface ActionButtonProps {
  primaryLabel: string;
  primaryDisabled?: boolean;
  onPrimaryClick: () => void;
  secondaryLabel?: string;
  secondaryDisabled?: boolean;
  onSecondaryClick: () => void;
  isLoading?: boolean;
}

export interface ModalProps {
  open: boolean;
  onClose?: () => void;
  children?: ReactNode;
  contentClassName?: string;
  dataTestId?: string;
}

const Modal = ({
  open,
  onClose = doNothing,
  children,
  contentClassName,
  dataTestId = 'modal-content',
}: ModalProps) => (
  <Transition appear show={open} as={Fragment}>
    <Dialog as="div" className="relative z-50" onClose={onClose} key="div">
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-[rgba(0,0,0,0.65)]" />
      </Transition.Child>
      <div className="fixed inset-0 flex items-center justify-center">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Dialog.Panel
            className={twMerge(
              'rounded-lg bg-white overflow-y-auto w-fit h-fit p-10 flex flex-col',
              contentClassName,
            )}
            data-testid={dataTestId}
          >
            {children}
          </Dialog.Panel>
        </Transition.Child>
      </div>
    </Dialog>
  </Transition>
);

export default Modal;
